import DocumentModule from "@/components/DocumentModule";

export default function Invoices() {
  return (
    <DocumentModule
      title="Invoices"
      subtitle="GST invoices, tax bills, retail receipts"
      endpoint="invoices"
      numberKey="invoice_number"
      dateKey="invoice_date"
      pageTestId="invoices-page"
    />
  );
}
